import { ComponentType } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/store";
import { addCurrentThemeClassToEle } from "@/utils";
import "./style.css";

export type WatchSectionNotFoundProps = {
  /** Lucide-style icon; omitted when missing. */
  icon?: ComponentType<{ size?: number; className?: string; strokeWidth?: number }>;
  iconSize?: number;
  title?: string;
  subtitle?: string;
  button?: string;
  onClick?: () => void;
};

/**
 * Empty state for watch accordions. Icon ring colors are shared for all sections
 * (light / dark) — see `style.css` on `.watchSectionNF-iconWrap`.
 */
export function WatchSectionNotFound({
  icon: Icon,
  iconSize = 40,
  title,
  subtitle,
  button,
  onClick,
}: WatchSectionNotFoundProps) {
  const currentTheme = useSelector((s: RootState) => s.currentThemeReducer.currentTheme);

  const showIcon = Icon != null;
  const showTitle = Boolean(title?.trim());
  const showSubtitle = Boolean(subtitle?.trim());
  const showButton = Boolean(button?.trim() && onClick);

  return (
    <div className={`watchSectionNF ${addCurrentThemeClassToEle(currentTheme, "watchSectionNF")}`}>
      {showIcon ? (
        <div className="watchSectionNF-iconWrap">
          <Icon size={iconSize} strokeWidth={1} className="watchSectionNF-icon" aria-hidden />
        </div>
      ) : null}
      {showTitle ? <h3 className="watchSectionNF-title">{title}</h3> : null}
      {showSubtitle ? <p className="watchSectionNF-subtitle">{subtitle}</p> : null}
      {showButton ? (
        <button type="button" className="watchSectionNF-btn" onClick={onClick}>
          {button}
        </button>
      ) : null}
    </div>
  );
}

export default WatchSectionNotFound;
